import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

var _dec, _class;

import { injectable } from 'inversify';
import 'reflect-metadata';
var LayerStylePlugin = (_dec = injectable(), _dec(_class = function () {
  function LayerStylePlugin() {
    _classCallCheck(this, LayerStylePlugin);
  }

  _createClass(LayerStylePlugin, [{
    key: "apply",
    value: function apply(layer) {
      layer.hooks.afterInit.tap('LayerStylePlugin', function () {
        layer.updateLayerConfig({});

        var _layer$getLayerConfig = layer.getLayerConfig(),
            autoFit = _layer$getLayerConfig.autoFit,
            fitBoundsOptions = _layer$getLayerConfig.fitBoundsOptions;

        if (autoFit) {
          setTimeout(function () {
            layer.fitBounds(fitBoundsOptions);
          }, 100);
        }
      });
    }
  }]);

  return LayerStylePlugin;
}()) || _class);
export { LayerStylePlugin as default };
//# sourceMappingURL=LayerStylePlugin.js.map